import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import UserAvatar from '@/_components/avatar/nuser/user.vue'
import LogAttachmentTemplate from '@/views/Log/components/attachment/attachment.vue'

import Log from '@/views/Log/models/log'
import Attachment from '@/views/Attachment/model/attachment'
import EditorJS from '@/_models/editorJS'
@Component({
    inheritAttrs: false,
    name: 'log-template',
    components: { UserAvatar, LogAttachmentTemplate },
})
export default class LogTemplate extends Mixins<MixinInterface>() {
    @Prop({ required: true }) log!: Log
    @Prop({ default: null }) oldAttachment!: null | {
        fileId: string
        filename: string
    }
    @Prop({ default: null }) newAttachment!: null | {
        fileId: string
        filename: string
    }

    @Prop({ default: null }) attachment!: null | {
        fileId: string
        filename: string
    }

    @Prop({ default: null }) editorJS!: null | { oldVal: EditorJS; newVal: EditorJS }

    preview(attachment) {
        return attachment?.fileId ? Attachment.preview(attachment.fileId) : null
    }

    download(attachment) {
        Attachment.download(attachment)
    }

    errorOldAttachment = false
    errorNewAttachment = false
    errorAttachment = false
}
